import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Eye, EyeOff } from "lucide-react";
import coachlogo from "../../assets/Images/full-logo.png"
import Loader from "../../base-component/Loader/Loader";
import getCreepFingerprint from "../../base-component/getCreepFingerprint/getCreepFingerprint";
import { adminLoginApi } from "../../Services/ApiServices";


function Login() {
    const navigate = useNavigate();
    const [eyes, setEyes] = useState(0);
    const [texts, setTexts] = useState("password");
    const [isLoading, setIsLoading] = useState(false);
    let deviceId = localStorage.getItem("DeviceId");

    useEffect(() => {
        console.log("Device fingerprint:", deviceId);
        if (!deviceId) {
            getCreepFingerprint().then(id => {
                localStorage.setItem("DeviceId", id);
            })
        }
    }, [deviceId]);

    const handleEyes = () => {
        const flag = eyes === 0 ? 1 : 0;
        setEyes(flag);

        const text = texts === "password" ? "text" : "password";
        setTexts(text);
    };

    const initialValues = {
        email: "",
        password: "",
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .email("Please enter a valid email address")
            .required("Please enter email address"),
        password: Yup.string()
            .required("Please enter password")
            .min(8, "Password must be at least 8 characters")
            .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
            .matches(/[a-z]/, "Password must contain at least one lowercase letter")
            .matches(/[0-9]/, "Password must contain at least one number")
            .matches(/[@$!%*?&]/, "Password must contain at least one special character"),
    });

    const handleSubmit = async (values) => {
        setIsLoading(true);
      let param = {
        email: values.email,
        password: values.password,
        device_id: deviceId,
        device_token: "abc",
        device_type: "Web"
      }

        adminLoginApi(param)
        .then(res => {
            console.log(res);
            if (res.data.status ==1) {
                localStorage.setItem("coach-admin-token", res.data.access_token);
                localStorage.setItem("coach-admin-refresh-token", res.data.refresh_token);
                navigate("/dashboard");
                toast.success(res.data.message);
            } else {
                toast.error(res.data.message);
            }
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
            console.log(err);
            toast.error(err.response.data.message);
        })
    };

    return (
        <div className="grid grid-cols-12 gap-x-6 fontNew">
            <div className="lg:col-span-6 h-[100vh] w-full 2xl:flex xl:flex lg:flex hidden bg-[#2C5BA7]">
                <div className="w-full flex flex-col justify-center items-center">
                    <img src={coachlogo} className="h-[230px]" alt="" />
                </div>
            </div>

            <div className="lg:col-span-6 col-span-12 mx-5">
                <div className="text-start flex justify-center items-center w-full h-[100vh]">
                    <div className="sm:max-w-lg w-full">
                        <div className="lg:hidden flex justify-center mb-10">
                            <img src={coachlogo} alt="" className="h-[200px]"/>
                        </div>

                        <h4 className="fontNew sm:text-3xl text-xl font-semibold pb-3">
                            Welcome Admin
                        </h4>

                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={handleSubmit}
                        >
                            {({ errors, touched }) => (
                                <Form>
                                    <div>
                                        <div className="flex items-center mt-3">
                                            <p className="fontNew text-sm font-medium">
                                                Email Address
                                            </p>
                                        </div>
                                        <div className="mt-3 mb-4">
                                            <div className="w-full flex mt-3 mb-1 items-center">
                                                <Field
                                                    type="email"
                                                    name="email"
                                                    autoComplete="off"
                                                    className={`bg-transparent px-4 rounded-xl border w-full outline-secondary h-[54px] text-base ${errors.email && touched.email ? "border-red-500" : "border-slate-300"
                                                        }`}
                                                    placeholder="Email"
                                                />
                                            </div>
                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-red-500 text-sm"
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="flex items-center mt-3">
                                            <p className="fontNew text-sm font-medium">
                                                Password
                                            </p>
                                        </div>
                                        <div className="mt-3 mb-4">
                                            <div className="w-full flex mt-3 mb-1 items-center">
                                                <Field
                                                    type={texts}
                                                    name="password"
                                                    autoComplete="off"
                                                    className={`bg-transparent ps-4 pe-12 rounded-xl border w-full outline-secondary h-[54px] text-base ${errors.password && touched.password ? "border-red-500" : "border-slate-300"
                                                        }`}
                                                    placeholder="Password"
                                                />
                                                {!eyes == 0 ? (
                                                    <Eye
                                                        onClick={handleEyes}
                                                        className="p-2 w-10 h-8 -ms-12 cursor-pointer text-gray-400"
                                                    />
                                                ) : (
                                                    <EyeOff
                                                        onClick={handleEyes}
                                                        className="p-2 w-10 h-8 -ms-12 cursor-pointer text-gray-400"
                                                    />
                                                )}
                                            </div>
                                            <ErrorMessage
                                                name="password"
                                                component="div"
                                                className="text-red-500 text-sm"
                                            />
                                        </div>
                                    </div>
                                    <div className="mt-6">
                                        <button
                                            type="submit"
                                            disabled={isLoading}
                                            className="w-full bg-[#4373c1] text-white h-12 px-4 rounded-xl font-medium hover:bg-[#2C5BA7] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            {isLoading ? <Loader /> : "Sign In"}
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
